






import {Component, Vue} from 'vue-property-decorator';
import DesktopDashboard from '@/views/dashboard/DesktopDashboard.vue';
import MobileDashboard from '@/views/dashboard/MobileDashboard.vue';
import {Can} from '@casl/vue';
import {MeasurementData} from '@/views/system/measurements/interfaces';
import measurementsModule from '@/store/modules/entities/measurementsModule';

@Component({
  components: {
    DesktopDashboard,
    MobileDashboard,
    Can,
  },
})
export default class DashboardView extends Vue {
  measurements: MeasurementData[] = [];

  async created() {
    try {
      await measurementsModule.fetchAll();
      this.measurements = [...measurementsModule.all];
    } catch (e) {
      this.measurements = [];
    }
  }
}
